import React from "react";
import type { CardItem, CardsProps } from "../../interfaces/componentInterfaces/cards";
import "./Cards.scss";

const Cards: React.FC<CardsProps> = ({
  cards,
  className = "",
  gridColumns,
  cardClassName = "",
  renderCard,
}) => {
  const gridStyle = gridColumns
    ? {
        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
      }
    : undefined;

  const formatCardValue = (value: number | string): string => {
    return typeof value === "number" ? value.toLocaleString() : value;
  };

  const renderDefaultCard = (card: CardItem, index: number) => (
    <div key={card.id || index} className={`card ${cardClassName}`}>
      <div className="card-header">
        {card.value !== undefined && (
          <p className="card-value">{formatCardValue(card.value)}</p>
        )}
      </div>
      <div className="card-body">
        <p className="card-title">{card.title}</p>
        {card.subtitle && <p className="card-subtitle">{card.subtitle}</p>}
      </div>
    </div>
  );

  return (
    <section className={`cards-container ${className}`}>
      <div className="cards-grid" style={gridStyle}>
        {cards.map((card, index) =>
          renderCard ? renderCard(card, index) : renderDefaultCard(card, index)
        )}
      </div>
    </section>
  );
};

export default Cards;
